'use strict';
const angular = require('angular');

export class AddPatientController {
  /*@ngInject*/
  constructor(appConfig, $uibModalInstance, $state, $http, incidentId) {
    'ngInject';

    this.constants = appConfig;
    this.modal = $uibModalInstance;
    this.$state = $state;
    this.$http = $http;
    this.patient = {
      IncidentId: incidentId
    };
  }

  create() {
    if(!this.patient.name) {
      this.error = 'Name is required.';
      return;
    }

    this.$http.post('/api/patients', this.patient)
    .then(result => {
      this.modal.close(result.data);
    });
  }
}

export default angular.module('hccApp.addPatient', [])
  .controller('AddPatientController', AddPatientController)
  .name;



// WEBPACK FOOTER //
// ./client/app/incident/patient/addPatient.controller.js